import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    progressBarContainer: {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.contrastText,
      padding: 0,
      width: '80%',
      marginLeft: '20%',
      margin: '0 auto',
      height: '3px',
      borderRadius: '4px',
      overflow: 'hidden'
    },

    progressBar: {
      backgroundColor: theme.palette.primary.main,
    },
  })
);

let ProgressBar = (props: any) => {
  const classes = useStyles();
  

  return (
    <div className = { classes.progressBarContainer }>
      <div className = { classes.progressBar} style={{width: `${props.percentage}%`}}>&nbsp;</div>
    </div>
  )
}

export default ProgressBar;